import React from "react";
import { FormContext } from "./FormContext";
import Api from "../api/Api";

export default class Form extends React.Component {
	constructor(props) {
		super(props);

		this.form = React.createRef();

		this.handleSubmit = this.handleSubmit.bind(this);

		this.inputs = {};
		this.initInput = (name, value, setValue, setError) => {
			this.inputs[name.toLowerCase()] = { name: name, setValue: setValue, setError: setError };
			this.setState({ [name]: value });
		}
		this.removeInput = (name) => {
			delete this.inputs[name.toLowerCase()];
		}
		this.changed = (name, value) => {
			this.setState({ [name]: value });
			this.inputs[name.toLowerCase()].setError(false);
		}
		this.hasFiles = () => {
			this.useFormData = true;
		}
	}

	handleSubmit(e, action) {
		if (e) e.preventDefault();
		for (let i in this.inputs)
			this.inputs[i].setError(false);
		var state = Object.assign({}, this.state);
		const cont = (cont) => {
			if (!cont)
				return false;
			Api.put(action ?? this.props.action, state, response => {
				if (response.data.formErrors) {
					Object.keys(response.data.formErrors).map((key) => this.addError(key, T(response.data.formErrors[key])));
					return false;
				}
				this.props.onSuccess(response);
			}, this.props.redirectOnSuccess, this.useFormData || this.props.hasFiles);
		}
		if (typeof this.props.beforeSubmit !== 'undefined') {
			var res = this.props.beforeSubmit(state, this.addError);
			if (res.then)
				res.then(res => cont(res));
			else cont(res);
		}
		else
			cont(true);
	}

	submit(validate = true, action = null) {
		if (!validate || this.form.current.reportValidity())
			this.handleSubmit(null, action);
	}

	setValues = (values) => {
		Object.keys(values).map(input => {
			let tinput = this.inputs[input.toLowerCase()];
			if (tinput) {
				tinput.setValue(values[input]);
				if (this.state) this.state[tinput.name] = values[input];
				this.setState({ [tinput.name]: values[input] });
			}
		});
	}

	clearInputs = () => {
		if (this.state)
			Object.keys(this.state).map(key => { delete this.state[key] });
	}

	addError = (input, message) => {
		this.inputs[input.toLowerCase()].setError(message);
	}

	render() {
		return (
			<FormContext.Provider value={{ setValue: this.changed, initInput: this.initInput, removeInput: this.removeInput, readOnly: this.props.readOnly, hasFiles: this.hasFiles }}>
				<form ref={this.form} className={this.props.className} data-id={this.props.dataId} onSubmit={this.handleSubmit}>
					{this.props.children}
				</form>
			</FormContext.Provider>
		);
	}
}